<div class="task-actions">
  @switch (mode) {
    @case (TaskActionsMode.Incoming) {
      @if (!isAudioTask) {
        <button class="action-btn accept" [disabled]="actionInProgress" (click)="onAccept()">
          <i [nimbusIcon]="acceptIcon" [iconWeight]="IconWeight.Regular"></i>
          <span class="action-text">{{ TranslationKeys.GeneralAccept | translate }}</span>
        </button>
        <button class="action-btn decline" [disabled]="actionInProgress" (click)="onDecline()">
          <i [nimbusIcon]="declineIcon" [iconWeight]="IconWeight.Regular"></i>
          <span class="action-text">{{ declineLabel | translate }}</span>
        </button>
      }
    }
    @case (TaskActionsMode.Connected) {
      @if (showJoinConversation) {
        <button class="action-btn primary" (click)="onJoinConversation()">
          <i [nimbusIcon]="ICONS.EXTERNAL_LINK" [iconWeight]="IconWeight.Regular"></i>
          <span class="action-text">{{ TranslationKeys.AssistantMySessions | translate }}</span>
        </button>
      }
      @if (showCloseTask) {
        <button class="action-btn terminate" [disabled]="actionInProgress" (click)="onCloseTask()">
          <i [nimbusIcon]="ICONS.CLOSE" [iconWeight]="IconWeight.Regular"></i>
          <span class="action-text">{{ TranslationKeys.CallCloseTask | translate }}</span>
        </button>
      }
    }
    @case (TaskActionsMode.Parked) {
      <button class="action-btn primary" (click)="onOpenMySessions()">
        <i [nimbusIcon]="ICONS.EXTERNAL_LINK" [iconWeight]="IconWeight.Regular"></i>
        <span class="action-text">{{ TranslationKeys.AssistantMySessions | translate }}</span>
      </button>
    }
  }
</div>
